import React, { useEffect, useState } from "react";
import { SectionWrapper } from "../../../../UI/SectionWrapper/SectionWrapper";
import { Accordion, AccordionSummary } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { AssetAccordionDetails } from "../../../ui-components/pageLayout/TableSettingsComponents";
import { FieldArray } from "formik";
import { EntitySelectionTable } from "../../../ui-components/pageLayout/EntitySelectionTable";
import { fromJson } from "../../../../../models/modelHelpers";
import { CMSTag } from "../../../../../models/CMS/cmsTag";
import { useSelector } from "react-redux";
import { getTagsSelector } from "../../../store/reducers/cmsReducer";

const TagsAccordion: React.FC = () => {
  const tags = useSelector(getTagsSelector);
  const [filteredTags, setFilteredTags] = useState<CMSTag[]>();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const allowedTags = tags.filter(
      (tag) => tag.getType() === "other" || tag.getType() === "logo"
    );
    setFilteredTags(allowedTags);
  }, [tags]);

  const tagSearchFunc = (query: string) => {
    const allowedTags = tags.filter(
      (tag) => tag.getType() === "other" || tag.getType() === "logo"
    );
    setFilteredTags(
      allowedTags.filter((tag) =>
        tag.getDisplayName().toLowerCase().includes(query.toLowerCase())
      )
    );
  };

  return (
    <SectionWrapper>
      <Accordion onChange={(event, expanded) => setIsOpen(expanded)}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="accordion-summary-gray"
        >
          Tags
        </AccordionSummary>
        <AssetAccordionDetails>
          <FieldArray
            name="tags"
            render={({ push, remove, form }) => {
              //quickfix for rendering alot of rows in EntitySelectionTable with images that slows down rerendering
              if (!isOpen) return;
              // Filter current tags to only show non-genre tags
              const currentNonGenreTags = (form.values.tags || [])
                .map((entity) => fromJson(CMSTag, entity) as CMSTag)
                .filter(
                  (tag) => tag.getType() === "other" || tag.getType() === "logo"
                );

              return (
                <EntitySelectionTable
                  label="tags"
                  values={filteredTags}
                  selectedValues={currentNonGenreTags}
                  searchFunction={tagSearchFunc}
                  push={(entity) => {
                    const tag = entity as CMSTag;
                    // Only add if not already in tags array
                    const exists = form.values.tags?.some(
                      (t) => t.tagId === tag.tagId
                    );
                    if (!exists) {
                      push(tag.serialize());
                    }
                  }}
                  remove={(index) => {
                    // Find the actual index in the tags array
                    const nonGenreTag = currentNonGenreTags[index];
                    const actualIndex = form.values.tags?.findIndex(
                      (t) => t.tagId === nonGenreTag.tagId
                    );
                    if (actualIndex !== -1) {
                      remove(actualIndex);
                    }
                  }}
                />
              );
            }}
          />
        </AssetAccordionDetails>
      </Accordion>
    </SectionWrapper>
  );
};

export default TagsAccordion;
